var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowSure01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "160px",
    viewBox: "33.518 75.67 160 160",
    enableBackground: "new 33.518 75.67 160 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F26666",
    d: "M113.518,75.67c-44.183,0-80,35.816-80,80c0,44.183,35.817,80,80,80s80-35.817,80-80 C193.518,111.486,157.7,75.67,113.518,75.67z M113.518,215.634c-33.119,0-59.967-26.848-59.967-59.967 c0-33.117,26.848-59.965,59.967-59.965c33.119,0,59.967,26.848,59.967,59.965C173.484,188.789,146.637,215.634,113.518,215.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C12D2D",
    d: "M104.02,165.982c-0.139-9.078,3.102-15.52,9.502-20.43c2.639-2.022,5.386-3.94,7.427-6.621 c4.852-6.367,2.257-13.299-5.62-14.618c-5.985-1.003-11.191,0.208-14.768,5.847c-2.359,3.723-4.943,4.33-8.479,2.711 c-3.296-1.511-4.753-4.787-3.769-8.646c1.459-5.726,5.408-9.377,10.563-11.593c9.687-4.157,19.521-3.963,28.976,0.621 c10.604,5.141,14.075,16.332,8.733,26.887c-2.733,5.398-6.908,9.559-11.649,13.179c-4.504,3.438-6.943,7.778-6.826,13.599 c0.106,5.273-1.735,6.869-7.205,6.879c-5.012,0.009-6.696-1.689-6.883-6.95C104,166.231,104.02,165.615,104.02,165.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C12D2D",
    d: "M120.434,192.121c-0.024,5.283-4.393,9.619-9.629,9.559c-5.029-0.057-9.293-4.367-9.375-9.479 c-0.084-5.262,4.258-9.703,9.481-9.701C116.195,182.5,120.46,186.81,120.434,192.121z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowSure01);
export default __webpack_public_path__ + "static/media/window_sure-01.23e3c3899431f61f8bd15aee8ce71ced.svg";
export { ForwardRef as ReactComponent };